import { UBXFieldButtonGroup, UBXFieldCheckbox, UBXFieldDate, UBXFieldInput, UBXFieldRadio, UBXFieldSelect } from './fields.model';

export class UBXForm<TModel> {
    name: string;
    model: TModel;
    fields: Array<UBXField>;
}
interface IField {
    name: string;
    type: UBXFieldTypeEnum;

    label?: string;
    placeholder?: string;
    accent?: string;
    prefix?: UBXIcon;
    suffix?: UBXIcon;
    colSpan?: string | number;
    js?: string | number;
    as?: string | number;

    message?: UBXFieldMessage;
    error?: UBXFieldError;

    isDisabled?: boolean;
    isHidden?: boolean;
    isValid?: boolean;
    validation?: UBXFieldValidation;

    input?: UBXFieldInput;
    checkbox?: UBXFieldCheckbox;
    select?: UBXFieldSelect;
    date?: UBXFieldDate;
    radio?: UBXFieldRadio;
    buttonGroup?: UBXFieldButtonGroup;

    maxLength?: number;
}
export class UBXField {
    name: string;
    type: UBXFieldTypeEnum;
    label: string;

    placeholder: string;
    accent: string;
    prefix: UBXIcon;
    suffix: UBXIcon;
    colSpan: string | number;
    js: string | number;
    as: string | number;

    message: UBXFieldMessage;
    error: UBXFieldError;

    isDisabled: boolean;
    isHidden: boolean;
    isValid: boolean;
    validation: UBXFieldValidation;

    input: UBXFieldInput;
    checkbox: UBXFieldCheckbox;
    select: UBXFieldSelect;
    date: UBXFieldDate;
    radio: UBXFieldRadio;
    buttonGroup: UBXFieldButtonGroup;

    maxLength: number;

    constructor({
        name,
        type,
        label,

        placeholder = '',
        accent,
        prefix,
        suffix,
        colSpan,
        js,
        as,

        error,
        message,

        isDisabled = false,
        isHidden = false,
        isValid = true,
        validation,

        input,
        checkbox,
        select,
        date,
        radio,
        buttonGroup,

        maxLength,
    }: IField) {
        this.name = name;
        this.type = type;
        this.label = label;

        this.placeholder = placeholder;
        this.accent = accent;
        this.prefix = prefix;
        this.suffix = suffix;
        this.colSpan = colSpan;
        this.js = js;
        this.as = as;

        this.error = error;
        this.message = message;

        this.isDisabled = isDisabled;
        this.isHidden = isHidden;
        this.isValid = isValid;
        this.validation = validation;

        this.input = input;
        this.checkbox = checkbox;
        this.select = select;
        this.date = date;
        this.radio = radio;
        this.buttonGroup = buttonGroup;

        this.maxLength = maxLength;
    }
}

export enum UBXFieldTypeEnum {
    ButtonGroup = 'buttonGroup',
    Checkbox = 'checkbox',
    Input = 'input',
    Radio = 'radio',
    Select = 'select',
    Spacer = 'spacer',
    Textarea = 'textarea',
    Upload = 'upload',
}
export enum UBXInputTypeEnum {
    AlphaNumeric = 'alphaNumeric',
    Date = 'date',
    Iban = 'iban',
    Number = 'number',
    Password = 'password',
    Text = 'text',
}
export class UBXFieldValidation {
    required?: boolean;
}
export class UBXFieldMessage {
    type?: UBXFieldMessageEnum;
    show?: boolean;
    content?: string;
    accent?: string;
    align?: string;
}
export enum UBXFieldMessageEnum {
    Characters = 0,
    Custom = 1,
}
export class UBXFieldError {
    type?: UBXFieldErrorEnum;
    show?: boolean;
}
export enum UBXFieldErrorEnum {
    Required = 0,
}
export class UBXIcon {
    icon: string;
    tooltip?: UBXTooltip;
}
export class UBXTooltip {
    text: string;
    position: string;
}
